import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/default.json';
import ru from './locales/ru/default.json';

export const resources = {
  en,
  ru,
} as const;

i18n.use(initReactI18next).init({
  lng: 'en',
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['b', 'sup', 'strong', 'br', 'i'],
  },
  resources,
});

export default i18n;
